export const CouponCopy = () => ({
  copied: false,
  showCode: false,
  originalText: '',

  init() {
    const textElement = this.$el.querySelector('[data-coupon-text]');
    this.originalText = textElement?.getAttribute('data-coupon-text') || '';
  },

  handleMouseEnter() {
    this.showCode = true;
  },

  handleMouseLeave() {
    if (!this.copied) {
      this.showCode = false;
    }
  },

  async copyCode(code) {
    try {
      await navigator.clipboard.writeText(code);

      this.copied = true;
      this.showCode = false;

      setTimeout(() => {
        this.copied = false;
        this.showCode = false;
      }, 1000);

    } catch (error) {
      console.error('複製折價券代碼失敗:', error);
    }
  },

  getDisplayText(couponCode) {
    if (this.copied) {
      return '已複製';
    } else if (this.showCode) {
      return couponCode;
    } else {
      return this.originalText;
    }
  }
});
